<div class="d-flex flex-column h-100">
  <app-main-header *ngIf="!(isHeaderHidden$ | async)"></app-main-header>

  <div class="content main-content flex-fill">
    <router-outlet></router-outlet>
  </div>
</div>
